import React from 'react';
import { ModalController } from '../../components/Modal/ControlledModal';
import { useChanges, Form } from '../../components/Form/Form';
import { AsyncSearch } from '../../components/Form/AsyncSearch/AsyncSearch';
import { Label } from '../../components/Form/Label/Label';
import { RadioGroup } from '../../components/Form/Radio/RadioGroup';
import { handleError } from '../../model/notification';
import { createOwnership } from '../../model/ownerships';
import { t } from '../../locales/translate';
import { Stack } from '../../components/Stack/Stack';
import { Spacer } from '../../components/Spacer/Spacer';

export interface CompanyAssign {
  companyId?: string;
  role?: string;
}

interface Props {
  productId: string;
  type: 'Event' | 'Product';
  controller: ModalController<CompanyAssign>;
  onOwnershipCreated: () => void;
}

export function AssignCompany({ productId, type, controller, onOwnershipCreated }: Props): JSX.Element {
  const [, , model, trackChanges] = useChanges<CompanyAssign>({});

  async function handleOnSubmit(): Promise<void> {
    try {
      await createOwnership({
        productId,
        role: model.role,
        companyId: model.companyId,
      });
      onOwnershipCreated();
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  function checkIfCanSubmit(): boolean {
    if (model.companyId && model.role) {
      return true;
    }
    return false;
  }

  const translationModel = type === 'Event' ? t.model.event : t.model.product;
  return (
    <Form model={model} onInput={trackChanges}>
      {() => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: checkIfCanSubmit(),
        });
        return (
          <Stack>
            <AsyncSearch
              label={t.actions.select(t.model.company._name)}
              name="companyId"
              searchIn={['company']}
              required
            ></AsyncSearch>
            <Spacer size="none" />
            <Label title={t.model.permissions.setPermissionsForThisItem(translationModel._name)}></Label>
            <RadioGroup
              name="role"
              values={[
                {
                  label: t.model.role.observer,
                  value: 'observer',
                },
                {
                  label: t.model.role.editor,
                  value: 'editor',
                },
              ]}
            ></RadioGroup>
          </Stack>
        );
      }}
    </Form>
  );
}
